export default __webpack_public_path__ + "static/media/cal-update.502b676a.png";